import React from "react";

import "assets/styles/HeroFooter.scss";

import mastercard from "assets/img/mastercard.png";
import visa from "assets/img/visa.png";
import amex from "assets/img/amex.png";

const HeroFooter = ({ center }) => {
  return (
    <div className={center ? 'heroFooterCenter' : 'heroFooter'}>
      <img
        className={'heroFooterBrand'}
        src={mastercard}
        alt={"mastercard"}
      />
      <img className={'heroFooterBrand'} src={visa} alt={"visa"} />
      <img className={'heroFooterBrand'} src={amex} alt={"amex"} />
    </div>
  );
};

export default HeroFooter;
